/* Guarded Goods site script for "Impulse 10.0 New Theme" (2026-11-03). */

/* Cart status messages (WCAG 4.1.3). Impulse appends add-to-cart errors with no
   role and announces success without the product name; mirror both into one
   alert region. Carried from the old theme.liquid. */
(function () {
  function region() {
    var r = document.getElementById('A11yCartStatus');
    if (!r) {
      r = document.createElement('div');
      r.id = 'A11yCartStatus';
      r.className = 'visually-hidden';
      r.setAttribute('role', 'alert');
      r.setAttribute('aria-live', 'assertive');
      r.setAttribute('aria-atomic', 'true');
      document.body.appendChild(r);
    }
    return r;
  }
  function say(msg) {
    var r = region();
    r.textContent = '';
    window.setTimeout(function () { r.textContent = msg; }, 100);
  }
  document.addEventListener('ajaxProduct:error', function (e) {
    var m = (e.detail && e.detail.errorMessage) || '';
    say(typeof m === 'string' ? m : String(m));
  });
  document.addEventListener('ajaxProduct:added', function (e) {
    var p = e.detail && e.detail.product;
    say('Added to cart: ' + (p && p.title ? String(p.title) : 'item'));
  });
})();

/* Add to cart bar (Simplicity, adapted for Impulse 10). Lace and kiltie pages
   only (gg-assets sets data-gg-buybar on <html>), under 990 px. Once the real
   Add to cart button scrolls out of view, a slim bar shows the product, the
   chosen options and the price; its button presses the real one, so the
   theme's own cart code, variant and quantity are used. Steps aside when the
   real button is back in view or the footer is reached. */
(function () {
  // Impulse 10 re-renders the product section when an option changes, so every
  // element is looked up fresh on each update instead of once.
  function q(sel) { return document.querySelector(sel); }
  function meta() { return q('.product-single__meta'); }
  function start() {
    if (!document.documentElement.hasAttribute('data-gg-buybar')) return;
    if (!meta() || !meta().querySelector('button[name="add"]')) return;
    var mq = window.matchMedia('(max-width: 989px)');
    function real() {
      var m = meta(); if (!m) return null;
      var bs = m.querySelectorAll('button[name="add"]');
      for (var i = 0; i < bs.length; i++) { if (bs[i].offsetParent !== null) return bs[i]; }
      return null;
    }
    var bar = document.createElement('div');
    bar.className = 'gg-buybar';
    bar.hidden = true;
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Add to cart');
    bar.innerHTML = '<div class="gg-buybar__info"><p class="gg-buybar__name"></p><p class="gg-buybar__meta"></p></div>' +
      '<button type="button" class="btn gg-buybar__btn"></button>';
    document.body.appendChild(bar);
    var nameEl = bar.querySelector('.gg-buybar__name');
    var metaEl = bar.querySelector('.gg-buybar__meta');
    var btn = bar.querySelector('.gg-buybar__btn');
    function choice(m) {
      var vals = [];
      var picker = m.querySelector('kit-variant-picker, .kit-product-variant-picker') || m;
      Array.prototype.forEach.call(picker.querySelectorAll('select, input[type="radio"]:checked'), function (f) {
        if (f.name === 'id' || /jdgm/.test(f.className)) return;
        if (f.value) vals.push(f.value);
      });
      return vals.join(' / ');
    }
    function sync(r) {
      var m = meta();
      var t = m.querySelector('.product-single__title');
      var pr = m.querySelector('[data-product-price]');
      nameEl.textContent = t ? t.textContent.replace(/\s+/g, ' ').trim() : '';
      var p = pr ? pr.textContent.replace(/\s+/g, ' ').trim() : '';
      metaEl.textContent = [choice(m), p].filter(Boolean).join(' · ');
      btn.textContent = r.textContent.replace(/\s+/g, ' ').trim() || 'Add to cart';
      btn.disabled = r.disabled;
    }
    var queued = false;
    function update() {
      queued = false;
      var r = real();
      var foot = q('.site-footer');
      var show = false;
      if (r && mq.matches) {
        var past = r.getBoundingClientRect().bottom < 0;
        var atFoot = foot && foot.getBoundingClientRect().top < window.innerHeight;
        show = past && !atFoot;
      }
      if (show) sync(r);
      bar.hidden = !show;
      document.body.classList.toggle('gg-buybar-on', show);
    }
    function queue() { if (!queued) { queued = true; window.requestAnimationFrame(update); } }
    btn.addEventListener('click', function () { var r = real(); if (r) r.click(); });
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    document.addEventListener('change', function () { setTimeout(queue, 300); });
    if ('MutationObserver' in window) {
      new MutationObserver(function () { if (!bar.hidden) queue(); })
        .observe(document.querySelector('main') || document.body, { childList: true, subtree: true, characterData: true });
    }
    update();
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', start); } else { start(); }
})();
